import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './IconButton.module.scss';

const cx = classNames.bind(styles);

const IconButton = ({ Icon, type = 'normal', ...rest }) => {
  return (
    <button type="button" className={cx(['button', type])} {...rest}>
      <Icon color="white" />
    </button>
  );
};

IconButton.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  type: PropTypes.oneOf(['normal', 'mini']),
};

export default React.memo(IconButton);
